<template>
  <div class="c_a-input">
    <ul class="inline_block c_a-list clearBoth" @click="setChip">
      <li class="award-icon a_10" data-chip="10"></li>
      <li class="award-icon a_50" data-chip="50"></li>
      <li class="award-icon a_100" data-chip="100"></li>
      <li class="award-icon a_500" data-chip="500"></li>
      <li class="award-icon a_1000" data-chip="1000"></li>
    </ul>

    <!-- <event tag="button" class="conf t_btn-d">设置</event>-->

    <el-input class="i"
                     :value="$store.state.inputnum"
                     type="text"
                     @keydown="validateKeydown"
                     @input="onInput"
                     placeholder="输入筹码"
                     :min="0" :controls="false" :precision="0" style="width:180px"/>
    <event tag="button" class="certain t_btn-d active" @click="onSubmit">确定</event>
    <event tag="button" class="reOrder t_btn-d" @click="onSubmitAgain">重复上次下单</event>
    <event tag="button" class="reset t_btn-d" @click="reset">重置</event>
    <!--<event tag="button" class="reset t_btn-d" @click="rapidBetVisible = true" v-if="isQuickStatus()">快速下注</event>-->
    <!--    <button-->
    <!--      class="reset t_btn-d all_select_bt"-->
    <!--      @click="onSelect('all')"-->
    <!--      v-show="!item.option.length&&item.select_all"-->
    <!--    >全选-->
    <!--    </button>-->
    <!--    <Dropdown :hide-on-click="false" @command="onSelect">-->
    <!--      <button class="reset t_btn-d all_select_bt" v-show="item.option.length&&item.select_all">-->
    <!--        全选-->
    <!--        <i class="el-icon-arrow-down el-icon&#45;&#45;right"/>-->
    <!--      </button>-->
    <!--      <DropdownMenu slot="dropdown">-->
    <!--        <DropdownItem v-for="(item ,i) in item.option" :key="i" :command="i">-->
    <!--          <Checkbox :checked="checkboxArray[i]" :disabled="isDisable" :key="checkboxKeyArray[i]"/>-->
    <!--          <span class="dropdown_item_span">{{ item }}</span>-->
    <!--        </DropdownItem>-->
    <!--      </DropdownMenu>-->
    <!--    </Dropdown>-->
    <!--<Dialog
      title="快速投注"
      :visible.sync="rapidBetVisible"
      width="1100px"
      :before-close="onRapidBeforeClose"
      custom-class="quickDialog"
    >
      <el-row type="flex" class="row-bg" justify="center" align="middle">
        <label>下注金额:</label>
        <el-autocomplete
          size="mini"
          class="quick-inline-input"
          v-model="rapidValue"
          :value="rapidValue"
          value-key="label"
          :fetch-suggestions="querySearch"
          placeholder="请输入内容"
          @select="handleSelect"
        ></el-autocomplete>
        <Button type="primary" @click="onQuickSubmit" size="mini" class="quickBtn">确 定</Button>
        <Button type="primary" @click="onResetRapidValue" size="mini" class="quickBtn">清空</Button>
      </el-row>

      <div class="quickNumberRow">
        <p class="quickTitle">彩球号码</p>
        <el-row type="flex" class="rowContainer rowNumbers" justify="center" align="middle">
          <span v-for="(item, index) in generateNumber('number')"
                :key="index"
                class="number number-radiu"
                :class="[getNumberColor(item), getNumberActive(item, 'rapidNumbers')]"
                @click="onQuickClick(item)"
          >{{ item }}</span>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <p class="quickTitle">单双大小</p>
            <el-row type="flex" class="rowContainer" justify="center" align="middle">
            <span v-for="(item, index) in generateNumber('danshuang')"
                  :key="index"
                  class="number"
                  :class="[getNumberActive(item)]"
                  @click="onQuickPlay(item)"
            >{{ item }}</span>
            </el-row>
          </el-col>
          <el-col :span="12">
            <p class="quickTitle">半波</p>
            <el-row type="flex" class="rowContainer" justify="center" align="middle">
            <span v-for="(item, index) in generateNumber('banbo')"
                  :key="index"
                  class="number"
                  :class="[getNumberColor(item), getNumberActive(item)]"
                  @click="onQuickPlay(item)"
            >{{ item }}</span>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <p class="quickTitle">生肖</p>
            <el-row type="flex" class="rowContainer" justify="center" align="middle">
          <span v-for="(item, index) in generateNumber('shengxiao')"
                :key="index"
                class="number"
                :class="[getNumberActive(item)]"
                @click="onQuickPlay(item)"
          >{{ item }}</span>
            </el-row>
          </el-col>
          <el-col :span="12">
            <p class="quickTitle">色波</p>
            <el-row type="flex" class="rowContainer" justify="center" align="middle">
          <span v-for="(item, index) in generateNumber('sebo')"
                :key="index"
                class="number"
                :class="[getNumberActive(item)]"
                @click="onQuickPlay(item)"
          >{{ item }}</span>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="12">
            <p class="quickTitle">头数</p>
            <el-row type="flex" class="rowContainer" justify="center" align="middle">
          <span v-for="(item, index) in generateNumber('tou')"
                :key="index"
                class="number"
                :class="[getNumberActive(item)]"
                @click="onQuickPlay(item)"
          >{{ item }}</span>
            </el-row>
          </el-col>
          <el-col :span="12">
            <p class="quickTitle">尾数</p>
            <el-row type="flex" class="rowContainer" justify="center" align="middle">
          <span v-for="(item, index) in generateNumber('wei')"
                :key="index"
                class="number"
                :class="[getNumberActive(item)]"
                @click="onQuickPlay(item)"
          >{{ item }}</span>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <el-row type="flex" class="quickFoot" justify="center" align="middle">
        <Button @click="onRapidBeforeClose" size="mini">取 消</Button>
        <Button type="primary" @click="onQuickSubmit" size="mini" class="quickBtn">确 定</Button>
      </el-row>
    </Dialog>-->
  </div>
</template>

<script>
import Vue from "../../utils/bus";
import {
  Autocomplete,
  Button,
  Checkbox,
  Col,
  Dialog,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  InputNumber,
  Input,
  Message,
  Row
} from 'element-ui';

import objectPath from 'object-path';
import {  mapActions, mapState  } from "vuex";

export default {
  name: "index",
  model: {
    prop: "value",
    event: "input"
  },
  props: {
    value: {
      type: [Number, String],
      default: ""
    }
  },
  data() {
    return {
      modal: false,
      checkboxArray: [],
      lastCheckboxArray: [],
      checkboxKeyArray: [],
      isDisable: false,
      inputnumber: "",
      item: {
        option: [],
        select_all: false
      },
      rapidBetVisible: false, // 快速下注
      rapidValue: '',
      rapidList: [{
        "value": '1', label: '下注1元'
      }, {
        "value": '5', label: '下注5元'
      }, {
        "value": '10', label: '下注10元'
      }, {
        "value": '20', label: '下注20元'
      }],
      rapidNumbers: [], // 投注的号码数组
      rapidPlayValues: [], // 快速投注玩法
      rapidPlayValuesObj: {}, // 快速投注玩法对象
    };
  },
  components: {
    Button,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    Checkbox,
    Dialog,
    ElAutocomplete: Autocomplete,
    ElRow: Row,
    ElCol: Col,
    elInputNumber: InputNumber,
    elInput: Input
  },
  created() {
    Vue.$on("onTab", item => {
      if (item) {
        this.item = item;
        this.item.option.forEach((item, index) => {
          this.checkboxArray[index] = false;
          this.checkboxKeyArray[index] = index;
        });
        Vue.$emit("resetDefault");
      }
    });
    Vue.$on("reset", item => {
      this.reset();
    });
    Vue.$on("resetInput", item => {
      this.$emit("input", "");
    });
    Vue.$on('changeTime', (item) => {
      this.isDisable = item ? false : true;
      if (!item) {
        this.item.option.forEach((item, index) => {
          this.checkboxArray[index] = false;
          this.checkboxKeyArray[index] = index;
        });
        Vue.$emit("resetDefault");
      }
    });
  },
  deactivated() {
    Vue.$off("resetInput");
    Vue.$off("changeTime");
    Vue.$off("onTab");
    Vue.$off("reset");
  },
  watch: {
    checkboxArray() {
      // this.timer()
    }
  },
  destroyed() {
    clearTimeout(this.timer);
    this.onQuickReset();
  },
  computed: {
    ...mapState({
      lhTabData: state => state.home.lhTabData,
      curTab: state => state.home_PK10.curTab,
      tabs: state => state.home_PK10.tabs,
      shengxiaoData: state => state.home_PK10.shengxiaoData,
    }),
  },
  methods: {
    ...mapActions({
        onSetPlayDantuoTotal: 'home/onSetPlayDantuoTotal',
        onSetLhItemTotal: 'home/onSetLhItemTotal'
    }),
    // 返回当前的玩法，没办法获取到lh的id判断，拿菜单名称判断（应该不会有重复的）
    getNowPlay() {
      return objectPath.get(this.tabs, `${this.curTab}.label`);
    },
    // 清空下单金额
    onResetRapidValue() {
      this.onQuickReset();
    },
    // 判断是否展示快速下单
    isQuickStatus() {
      if(this.item.label=='整合')
        return false;
      const label = this.getNowPlay();
      return (label === '特码' || label === '正码' || label === '正特');
    },
    // 快速下单 提交
    onQuickSubmit() {
      if (!this.rapidValue) {
        Message({message: "下注错误，未选择金额", type: "error"});
        return;
      }
      if (this.rapidNumbers.length === 0) {
        Message({message: "下注错误，未选择号码", type: "error"});
        return;
      }
      // 模拟数据
      const RAPID_NUMBER = [];
      let class1 = objectPath.get(this.lhTabData, 'label') || '特码';
      let played_name = objectPath.get(this.lhTabData, 'playedName');
      let class2 = played_name;
      let sub_category_id = objectPath.get(this.lhTabData, 'sub_category_id') || 1;
      const DEFAULT_NAME = {
        1: '特码A',
        2: '正码A',
        3: '正1特',
      }
      if (!played_name) {
        played_name = DEFAULT_NAME[sub_category_id];
        class2 = DEFAULT_NAME[sub_category_id];
      }
      // 根据需求，如果为正特，played_name为正特
      if (sub_category_id === 3 || played_name === DEFAULT_NAME[3]) {
        played_name = '正特';
      }
      this.rapidNumbers.forEach(item => {
        RAPID_NUMBER.push({
          class1,
          class2,
          class3: `${item}`,
          money: Number(this.rapidValue),
          played_name,
          status: 1,
        })
      });
      this.$emit('onQuickCreate', RAPID_NUMBER);
      this.rapidBetVisible = false;
      this.onQuickReset();
    },
    // 关闭快速下注弹框
    onRapidBeforeClose() {
      this.onQuickReset();
      this.rapidBetVisible = false;
    },
    // 快速下注 数据还原
    onQuickReset() {
      this.rapidValue = '';
      this.rapidPlayValues = [];
      this.rapidNumbers = [];
      this.rapidPlayValuesObj = [];
    },
    // 玩法lick
    onQuickPlay(play) {
      let NEW_RAPID_NUMBERS = [];
      switch (play) {
        case '大':
          for (let i = 25; i <= 49; i++) {
            NEW_RAPID_NUMBERS.push(i);
          }
          break;
        case '小':
          for (let i = 1; i < 25; i++) {
            NEW_RAPID_NUMBERS.push(i);
          }
          break;
        case '双':
          for (let i = 1; i < 49; i++) {
            if (i % 2 === 0) {
              NEW_RAPID_NUMBERS.push(i);
            }
          }
          break;
        case '单':
          for (let i = 1; i < 50; i++) {
            if (i % 2 === 1) {
              NEW_RAPID_NUMBERS.push(i);
            }
          }
          break;
        case '合双':
          NEW_RAPID_NUMBERS = [2, 4, 6, 8, 11, 13, 15, 17, 19, 20, 22, 24, 26, 28, 31, 33, 35, 37, 39, 40, 42, 44, 46, 48];
          break;
        case '合单':
          NEW_RAPID_NUMBERS = [1, 3, 5, 7, 9, 10, 12, 14, 16, 18, 21, 23, 25, 27, 29, 30, 32, 34, 36, 38, 41, 43, 45, 47, 49];
          break;
        case '合大':
          NEW_RAPID_NUMBERS = [7, 8, 9, 16, 17, 18, 19, 25, 26, 27, 28, 29, 34, 35, 36, 37, 38, 39, 43, 44, 45, 46, 47, 48];
          break;
        case '合小':
          NEW_RAPID_NUMBERS = [1, 2, 3, 4, 5, 6, 10, 11, 12, 13, 14, 15, 20, 21, 22, 23, 24, 30, 31, 32, 33, 40, 41, 42, 49];
          break;
        case '特尾大':
          NEW_RAPID_NUMBERS = [5, 6, 7, 8, 9, 15, 16, 17, 18, 19, 25, 26, 27, 28, 29, 35, 36, 37, 38, 39, 45, 46, 47, 48, 49];
          break;
        case '特尾小':
          NEW_RAPID_NUMBERS = [1, 2, 3, 4, 10, 11, 12, 13, 14, 20, 21, 22, 23, 24, 30, 31, 32, 33, 34, 40, 41, 42, 43, 44];
          break;
        case '红大':
          NEW_RAPID_NUMBERS = [29, 30, 34, 35, 40, 45, 46];
          break;
        case '红小':
          NEW_RAPID_NUMBERS = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24];
          break;
        case '红双':
          NEW_RAPID_NUMBERS = [2, 8, 12, 18, 24, 30, 34, 40, 46];
          break;
        case '红单':
          NEW_RAPID_NUMBERS = [1, 7, 13, 19, 23, 29, 35, 45];
          break;
        case '蓝大':
          NEW_RAPID_NUMBERS = [25, 26, 31, 36, 37, 41, 42, 47, 48];
          break;
        case '蓝小':
          NEW_RAPID_NUMBERS = [3, 4, 9, 10, 14, 15, 20];
          break;
        case '蓝双':
          NEW_RAPID_NUMBERS = [4, 10, 14, 20, 26, 36, 42, 48];
          break;
        case '蓝单':
          NEW_RAPID_NUMBERS = [3, 9, 15, 25, 31, 37, 41, 47];
          break;
        case '绿大':
          NEW_RAPID_NUMBERS = [27, 28, 32, 33, 38, 39, 43, 44];
          break;
        case '绿小':
          NEW_RAPID_NUMBERS = [5, 6, 11, 16, 17, 21, 22];
          break;
        case '绿双':
          NEW_RAPID_NUMBERS = [6, 16, 22, 28, 32, 38, 44];
          break;
        case '绿单':
          NEW_RAPID_NUMBERS = [5, 11, 17, 21, 27, 33, 39, 43];
          break;
        case '红波':
          NEW_RAPID_NUMBERS = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46];
          break;
        case '蓝波':
          NEW_RAPID_NUMBERS = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48];
          break;
        case '绿波':
          NEW_RAPID_NUMBERS = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49];
          break;
        case '0头':
          for (let i = 1; i < 10; i++) {
            NEW_RAPID_NUMBERS.push(i);
          }
          break;
        case '1头':
          for (let i = 10; i < 20; i++) {
            NEW_RAPID_NUMBERS.push(i);
          }
          break;
        case '2头':
          for (let i = 20; i < 30; i++) {
            NEW_RAPID_NUMBERS.push(i);
          }
          break;
        case '3头':
          for (let i = 30; i < 40; i++) {
            NEW_RAPID_NUMBERS.push(i);
          }
          break;
        case '4头':
          for (let i = 40; i < 50; i++) {
            NEW_RAPID_NUMBERS.push(i);
          }
          break;
        case '0尾':
          NEW_RAPID_NUMBERS = [10, 20, 30, 40];
          break;
        case '1尾':
          NEW_RAPID_NUMBERS = [1, 11, 21, 31, 41];
          break;
        case '2尾':
          NEW_RAPID_NUMBERS = [2, 12, 22, 32, 42];
          break;
        case '3尾':
          NEW_RAPID_NUMBERS = [3, 13, 23, 33, 43];
          break;
        case '4尾':
          NEW_RAPID_NUMBERS = [4, 14, 24, 34, 44];
          break;
        case '5尾':
          NEW_RAPID_NUMBERS = [5, 15, 25, 35, 45];
          break;
        case '6尾':
          NEW_RAPID_NUMBERS = [6, 16, 26, 36, 46];
          break;
        case '7尾':
          NEW_RAPID_NUMBERS = [7, 17, 27, 37, 47];
          break;
        case '8尾':
          NEW_RAPID_NUMBERS = [8, 18, 28, 38, 48];
          break;
        case '9尾':
          NEW_RAPID_NUMBERS = [9, 19, 29, 39, 49];
          break;
      }

      // 获取生肖号码
      const isShengxiao = this.shengxiaoData.find(item => item.sx === play);
      if (isShengxiao) {
        NEW_RAPID_NUMBERS = isShengxiao.m_number.split(',').map(item => Number(item));
      }

      // 保存全部，已play为key的数据对象
      this.rapidPlayValuesObj = {
        ...this.rapidPlayValuesObj,
        [play]: NEW_RAPID_NUMBERS
      };
      // 判断如果点击状态为取消玩法，删除掉该玩法
      const isExist = this.rapidPlayValues.find(key => key == play);
      if (isExist) {
        delete this.rapidPlayValuesObj[play];
      }
      // 追加合并数组
      let DEFAULT_NUMBERS_ARRAY = [];
      Object.keys(this.rapidPlayValuesObj).forEach(item => {
        DEFAULT_NUMBERS_ARRAY = DEFAULT_NUMBERS_ARRAY.concat(this.rapidPlayValuesObj[item]);
      });
      // 去重
      NEW_RAPID_NUMBERS = [...new Set(DEFAULT_NUMBERS_ARRAY)];

      // 更新保存玩法的函数
      this.quickClickGadget('rapidPlayValues', play);
      this.rapidNumbers = NEW_RAPID_NUMBERS;
    },
    // 快速点击方法
    quickClickGadget(target, value) {
      const isExist = this[target].find(key => key == value);
      // 判断是否存在
      if (isExist) {
        this[target] = this[target].filter(key => key != value);
      } else {
        this[target].push(value);
      }
    },
    // 号码click点击
    onQuickClick(number) {
      this.quickClickGadget('rapidNumbers', number);
    },
    // 号码是否选中
    getNumberActive(number, target = 'rapidPlayValues') {
      let isActive = this[target].find(key => key == number);
      return isActive ? 'number-active' : '';
    },
    // 获取号码颜色
    getNumberColor(number) {
      const RED_ARR = [1, 2, 7, 8, 12, 13, 18, 19, 23, 24, 29, 30, 34, 35, 40, 45, 46, '红大', '红小', '红双', '红单'];
      const BLUE_ARR = [3, 4, 9, 10, 14, 15, 20, 25, 26, 31, 36, 37, 41, 42, 47, 48, '蓝大', '蓝小', '蓝双', '蓝单'];
      const GREEN_ARR = [5, 6, 11, 16, 17, 21, 22, 27, 28, 32, 33, 38, 39, 43, 44, 49, '绿大', '绿小', '绿双', '绿单'];
      if (RED_ARR.indexOf(number) > -1) return 'number-red';
      if (BLUE_ARR.indexOf(number) > -1) return 'number-blue';
      if (GREEN_ARR.indexOf(number) > -1) return 'number-green';
      return '';
    },
    // 生成号码组
    generateNumber(type) {
      let NUMBER_ARR = [];
      switch (type) {
        case 'number':
          for (let i = 1; i < 50; i++) {
            NUMBER_ARR.push(i);
          }
          break;
        case 'danshuang':
          // 如果为正码的玩法
          if (this.getNowPlay() === '正码') {
            NUMBER_ARR = ['大', '小', '双', '单', '合双', '合单', '合大', '合小'];
          } else {
            NUMBER_ARR = ['大', '小', '双', '单', '合双', '合单', '合大', '合小', '特尾大', '特尾小'];
          }
          break;
        case 'banbo':
          NUMBER_ARR = ['红大', '红小', '红双', '红单', '蓝大', '蓝小', '蓝双', '蓝单', '绿大', '绿小', '绿双', '绿单'];
          break;
        case 'shengxiao':
          NUMBER_ARR = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];
          break;
        case 'sebo':
          NUMBER_ARR = ['红波', '蓝波', '绿波'];
          break;
        case 'tou':
          NUMBER_ARR = ['0头', '1头', '2头', '3头', '4头'];
          break;
        case 'wei':
          for (let i = 0; i < 10; i++) {
            NUMBER_ARR.push(`${i}尾`);
          }
          break;
      }
      return NUMBER_ARR;
    },
    handleSelect(item) {
      const {value} = item;
      this.rapidValue = value;
    },
    querySearch(queryString, cb) {
      var restaurants = this.rapidList;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        const value = (restaurant.value ? restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0 : false);
        return value;
      };
    },
    onSubmit() {
      this.$emit('certain');
    },
    timer() {
      return setTimeout(() => {
        this.$emit("input", this.inputnumber);

      }, 1000)
    },
    // 重置权限item
    onSubmitAgain() {
      this.$emit('again');
    },
    // 不允许非数字和输入
    validateKeydown(e) {
      if (!/[0-9]/.test(e.key) && e.keyCode !== 8) e.preventDefault();
    },
    onInput(e) {
      if(e<=0){
        e = '';
      }
      this.inputnumber = e;
      this.$store.state.inputnum = e;
      this.$emit("input", e);
    },
    setChip(e) {
      if (!e.target.dataset.chip) return;
      this.$emit(
        "input",
        (parseFloat(this.value) || 0) + (parseFloat(e.target.dataset.chip) || 0)
      );
      this.inputnumber = (parseFloat(this.value) || 0) + (parseFloat(e.target.dataset.chip) || 0)
      this.$store.state.inputnum = (parseFloat(this.value) || 0) + (parseFloat(e.target.dataset.chip) || 0);
    },
    reset() {
      this.$store.state.inputnum = '';
      this.$emit("input", "");
      this.$emit("reset");
      this.item.option.forEach((item, index) => {
        this.$set(this.checkboxArray, index, false);
        this.$set(this.checkboxKeyArray, index, new Date().getSeconds()); //利用key特性 使组件重新渲染
      });
      Vue.$emit("resetDefault");
      // 重置胆拖计算值
      this.onSetPlayDantuoTotal({});
      this.onSetLhItemTotal({});
    },
    onSelect(i) {
      if (this.isDisable) {
        Message({message: "暂停投注", type: "error"});
        // this.checkboxArray[i] = !this.checkboxArray[i];

        return false;
      } else if (i == "all") {
        Vue.$emit("changSelect", "all");
      } else {
        this.$set(this.checkboxArray, i, this.checkboxArray[i] ? false : true);
        this.$set(this.checkboxKeyArray, i, new Date().getSeconds()); //利用key特性 使组件重新渲染
        Vue.$emit("changSelect", this.item.option[i], this.checkboxArray);
        //快乐十分单号1-8，需请求全选才刷新
        if (this.$route.query.category_id == '1' && this.$route.query.index == '1') {
          this.$store.dispatch("home_gd_ha10/getCurOddsData", {
            sub_category_id: 2,
            lottery_type: this.$route.query.lottery_type || 1,
            category_id: this.$route.query.category_id || 1
          });
        }
      }
    }

  }
};
</script>

<style scoped lang="stylus">
.all_select_bt {
  width: 80px !important;
}

.dropdown_item_span {
  margin-left: 10px;
}

.c_a-input {
  display: flex;
  float:right;
  justify-content: space-between;
  padding: 2px 0 3px 3px;
  background-color: #fff;

  .conf, .certain, .reset, .reOrder {
    width: 73px;
    height: 35px;
    z-index:10
  }

  .reOrder {
    width: 108px;
  }

  button {
    margin-left: 10px;
    vertical-align: middle;
  }

  .certain, .reOrder, .reset {
    margin-left: 7px;
  }

  .conf {
    margin-left: 11px;
  }

  .c_a-list {
    display: inline-block;
    vertical-align: middle;

    > li {
      float: left;
      cursor: pointer;
      box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
      border-radius: 50%;
      transition: box-shadow 0.2s ease-in-out;

      &:hover {
        box-shadow: none;
      }
    }

    li + li {
      margin-left: 10px;
    }
  }

  .i-wrap {
    height: 35px;
    display: inline-block;
    margin-left: 7px;
    vertical-align: middle;

    .i {
      width: 130px !important;
      height: 35px !important;
      border: 1px solid #E6E6E6 !important;
      padding: 0 10px !important;

      box-sizing border-box {
        .drag-item {
          color: #333;
          height: 42px;
          z-index: 102x;
          line-height: 42px;
          background-color: #fff;
        }

        .drag-item + .drag-item {
          border-top: 1px solid #e6e6e6;
        }
      }

      input {
        width: 140px;
        height: 60px;
        border: 1px solid #d0d0d0;
        margin: 0 10px;
        text-align: center;
      }
    }
  }
}

.quick-inline-input {
  margin-left: 5px;
}

.quickTitle {
  padding: 5px 0;
  text-align: center;
  background: deepskyblue
  color: #fff;
}

.quickNumberRow {
  margin-top: 10px;
  border-radius: 2px;
  border: 1px solid #dadada;

  .rowContainer {
    flex-wrap: wrap;
    padding: 15px 0;

    .number-radiu {
      border-radius: 50%;
    }

    .number {
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 3px;
      padding: 0 1px;
      min-width: 25px;
      height: 25px;
      font-size: 12px;
      border: 1px solid #dadada;
      text-align: center;
      cursor: pointer;
    }
  }

  .rowNumbers {
    padding: 15px 170px;
  }

  .number-red {
    color: red;
  }

  .number-blue {
    color: blue;
  }

  .number-green {
    color: green;
  }

  .number-active {
    background: #fffa00;
  }
}

.quickFoot {
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/c_a-input/index.vue